import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatPriceNumber',
})
export class formatPriceNumber implements PipeTransform {
  transform(value: number): { main: string; cents: string } {
    const num = Number(value);
    const roundedNum = Math.floor(num);
    const cents = Math.round((num - roundedNum) * 100);

    const mainPart = new Intl.NumberFormat('ru-RU', {
      maximumFractionDigits: 0,
      useGrouping: true
    }).format(roundedNum);

    const centsPart = cents.toString().padStart(2, '0');

    return {
      main: mainPart,
      cents: centsPart
    };
  }
}
